export default __webpack_public_path__ + "static/media/bill.5b4f9bf2.svg";